import React from "react";
import {useSelector} from "react-redux";
import {selectApiBase, selectIsTestingMode} from "../redux/selectors/addresses";
import Api from "../api";
import {HealthCheckEvents} from "../api/types";

function useListenAllErrors() {
  const isTestingMode = useSelector(selectIsTestingMode);
  const adresses = useSelector(selectApiBase);

  const onError = (args) => {
    const error = new Error(args);

    Api.healthCheckFor(HealthCheckEvents.testingGroupsErrors).sendFailure(error.message)
  }

  React.useEffect(() => {
    if (isTestingMode && adresses) {
      window.onerror = onError
    }
  }, [isTestingMode, adresses])
}


export default useListenAllErrors
